import React from "react";
import LegalPageShell from "@/components/LegalPageShell";
import { useI18n } from "@/lib/i18n";

export default function DatenschutzPage() {
  const { t } = useI18n();
  return <LegalPageShell {...t.legal.datenschutz} testId="page-datenschutz" />;
}
